import Swiper from "swiper";

import {Pagination} from "swiper/modules";

export default class PushVideoJob{
    
    constructor(element) {
        this._wrapper = element;
        this._swiper = this._wrapper.querySelector('.swiper');
        
        this.init();
    }
    
    init(){
        this.slider = new Swiper(this._swiper, {
            slidesPerView:1,
            loop:true, 
            spaceBetween:24,
            centeredSlides: true,
            modules:[Pagination],
            pagination:{
                el:this._pagination,
                type:"bullets",
                clickable:true
            },
            breakpoints:{
                576:{
                    spaceBetween:40,
                    slidesPerView:2
                },
                992:{
                    spaceBetween:40,
                    slidesPerView:3
                },
                1200:{
                    spaceBetween:102,
                    slidesPerView:3
                }
            }
        });
    }
    
}